<template>
	<fieldset class="itv-input-checkbox">
		<input
			class="visually-hidden"
			type="checkbox"
			:id="id"
			:name="name"
			v-model="value"
			:ref="id"
			@change="$emit('change-event', value, id)"
		/>
		<label class="itv-input-checkbox__label" :for="id">
			{{ label }}
		</label>
	</fieldset>
</template>

<script>
export default {
	name: 'InputCheckbox',
	props: {
		label: {
			type: String,
			default: 'form',
		},
		id: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: 'agreement',
		},
	},
	data() {
		return {
			value: false,
		}
	},
	created() {
		const historyParam = new URLSearchParams(window.location.search).get(
			this.id.toLowerCase()
		)
		if (historyParam === 'Y') {
			this.value = true
		}
	},
}
</script>
